import { library, config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import {
  faArrowRight,
  faBullhorn,
  faScaleBalanced,
  faGear,
  faCoins,
  faPenRuler,
  faDiagramProject,
  /* @custom [Task: engagement models] */
  faRotate,
  faLifeRing,
  /* @custom [Task: chillswitch case study] */
  faLock,
  faShieldHalved,
  faWifi,
  faBan,
  faEyeSlash,
  faTriangleExclamation,
  faCircleQuestion,
  faQuoteLeft,
  faCheck,
  faClone,
  faChevronDown,
  faCube,
  faLanguage,
  faUsers,
  faCodeBranch,
  faPalette,
  faBolt,
  faRocket,
  faLayerGroup,
  faMoon,
  faSun,
  faPencil,
  faHighlighter,
  faLink,
  faList,
  faCheckCircle,
  faCalendar,
  faEnvelope,
  faShareNodes,
  faLocationDot,
  faPhone,
  faBrain,
  faWandMagicSparkles,
  faGauge,
  faBarsProgress,
  faTurnUp,
  faSearch,
  faCircleInfo,
  faDownload,
  faXmark,
  faPuzzlePiece,
  faTags,
  faDatabase,
  faClock,
  faMicrochip,
  faChevronUp,
  faTerminal,
  faChevronLeft,
  faChevronRight,
  // @custom-start [Task: Modernaut capability icons]
  faMobileScreenButton,
  faCartShopping,
  faArrowsRotate,
  faUniversalAccess,
  faCode,
  faServer,
  faCodeCompare,
  faTimeline,
  faFilePdf,
  faFileWord,
  faFileCode,
  faFileLines,
  // @custom-end
} from '@fortawesome/free-solid-svg-icons'
import {
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube,
  // @custom-start [Task: Modernaut footer social icons]
  faGithub,
  // @custom-end
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Prevent Font Awesome from adding its CSS since we did it manually above:
config.autoAddCss = false

// Register a curated set of icons we actually use in the site so string names can resolve.
library.add(
  faArrowRight,
  faBullhorn,
  faScaleBalanced,
  faGear,
  faCoins,
  faPenRuler,
  faDiagramProject,
  /* @custom [Task: engagement models] */
  faRotate,
  faLifeRing,
  /* @custom [Task: chillswitch case study] */
  faLock,
  faShieldHalved,
  faWifi,
  faBan,
  faEyeSlash,
  faTriangleExclamation,
  faCircleQuestion,
  faQuoteLeft,
  faCheck,
  faClone,
  faChevronDown,
  faCube,
  faLanguage,
  faUsers,
  faCodeBranch,
  faPalette,
  faBolt,
  faRocket,
  faLayerGroup,
  faMoon,
  faSun,
  faPencil,
  faHighlighter,
  faLink,
  faList,
  faCheckCircle,
  faCalendar,
  faEnvelope,
  faShareNodes,
  faLocationDot,
  faPhone,
  faBrain,
  faWandMagicSparkles,
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube,
  faGauge,
  faBarsProgress,
  faTurnUp,
  faSearch,
  faCircleInfo,
  faDownload,
  faXmark,
  faPuzzlePiece,
  faTags,
  faDatabase,
  faClock,
  faMicrochip,
  faChevronUp,
  faTerminal,
  faChevronLeft,
  faChevronRight,
  // @custom-start [Task: Modernaut capability and social icons]
  faMobileScreenButton,
  faCartShopping,
  faArrowsRotate,
  faUniversalAccess,
  faCode,
  faServer,
  faCodeCompare,
  faTimeline,
  faFilePdf,
  faFileWord,
  faFileCode,
  faFileLines,
  faGithub
  // @custom-end
)

export { FontAwesomeIcon }

/**
 * Helper to resolve an icon name to a FontAwesome icon prop.
 * Handles both solid and brand icons registered in the library.
 */
export function getIconProp(name: string): any {
  if (!name) return null

  // Known brand icons in our library
  // @custom-start [Task: Modernaut footer social icons]
  const brands = ['facebook-f', 'x-twitter', 'linkedin-in', 'instagram', 'youtube', 'github']
  // @custom-end
  if (brands.includes(name)) {
    return ['fab', name]
  }

  // Default to solid
  return name
}
